module.exports = __webpack_public_path__ + "static/kian.ca1caa14.png";


//////////////////
// WEBPACK FOOTER
// ./src/bios/img/kian.png
// module id = 233
// module chunks = 35783957827783 107818501498521